import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCalendar,
  IconCheck,
  IconDownload,
  IconEdit,
  IconSearch,
  IconStatusChange,
  IconX,
} from "@tabler/icons-react";
import axios from "axios";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  keySearchSPLU,
  repositoryDelivery,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { getTblDmEmployeeAll } from "../../../service/getSelectApi";
import UploadPriceList from "./UploadPriceList";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const SchedulePriceListUpload = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const _searchJson = localStorage.getItem(keySearchSPLU)
    ? JSON.parse(localStorage.getItem(keySearchSPLU) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.FromDate
        : new Date(
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() +
              7 * 3600 * 1000
          )?.toISOString(),
    ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : "",
    Status: _searchJson && checkedPinSearch ? _searchJson?.Status : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "fileName",
        header: "Tên file",
        Cell: ({ renderedCellValue, row }) => {
          const [hovered, setHovered] = React.useState(false);

          return (
            <Tooltip label="Tải tệp">
              <Text
                fw={500}
                size="12.5px"
                c={hovered ? "#1971c2" : "black"}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() =>
                  handleDownload(row.original.filePath, row.original.fileName)
                }
                style={{ width: "fit-content" }}
              >
                {renderedCellValue}
              </Text>
            </Tooltip>
          );
        },
      },
      // {
      //   accessorKey: "filePath",
      //   header: "Đường dẫn file",
      //   Cell: ({ renderedCellValue }) => {
      //     const [hovered, setHovered] = React.useState(false);

      //     return (
      //       <Tooltip label="Xem File">
      //         <Text
      //           fw={500}
      //           size="12.5px"
      //           c={hovered ? "#1971c2" : "black"}
      //           onMouseEnter={() => setHovered(true)}
      //           onMouseLeave={() => setHovered(false)}
      //           onClick={() => window.open(String(renderedCellValue))}
      //           style={{ width: "fit-content" }}
      //         >
      //           {renderedCellValue}
      //         </Text>
      //       </Tooltip>
      //     );
      //   },
      // },
      {
        accessorKey: "scheduleDate",
        header: "Ngày thực hiện",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null && renderedCellValue !== undefined ? (
            <Badge
              color={
                renderedCellValue === 0
                  ? "blue"
                  : renderedCellValue === 1
                  ? "teal"
                  : renderedCellValue === 2
                  ? "red"
                  : "gray"
              }
            >
              {renderedCellValue === 0
                ? "Đã lên lịch"
                : renderedCellValue === 1
                ? "Cập nhật thành công"
                : renderedCellValue === 2
                ? "Cập nhật thất bại"
                : "Hủy cập nhật"}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "completionDate",
        header: "Ngày hoàn thành cập nhật",
        size: 250,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      // { accessorKey: "type", header: "Loại" },
      {
        accessorKey: "description",
        header: "Mô tả",
        size: 300,
      },
      {
        accessorKey: "createdBy",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "lastUpdatedBy",
        header: "Người cập nhật cuối",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdatedDate",
        header: "Ngày cập nhật cuối",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"start"} gap={"xs"} align={"center"}>
            <Tooltip label="Tải tệp">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() =>
                  handleDownload(row.original.filePath, row.original.fileName)
                }
              >
                <IconDownload size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Cập nhật">
              <ActionIcon
                variant="light"
                color="orange"
                onClick={() => modalsUpload("EDIT", row.original)}
                disabled={row.original.status !== 0}
              >
                <IconEdit size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Hủy lịch cập nhật">
              <ActionIcon
                variant="light"
                color="red"
                onClick={() => modalsCancel(row.original.id)}
                disabled={row.original.status !== 0}
              >
                <IconX size={16} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataEmployee]
  );

  const optionStatus: Record<
    | "Đã lên lịch"
    | "Cập nhật thành công"
    | "Cập nhật thất bại"
    | "Hủy cập nhật",
    string
  > = {
    "Đã lên lịch": "blue",
    "Cập nhật thành công": "teal",
    "Cập nhật thất bại": "red",
    "Hủy cập nhật": "gray",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionStatus[
            option.label as
              | "Đã lên lịch"
              | "Cập nhật thành công"
              | "Cập nhật thất bại"
              | "Hủy cập nhật"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const modalsUpload = (method: string, data?: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Lập lịch cập nhật bảng giá</Title>,
      size: "auto",
      children: (
        <UploadPriceList method={method} data={data} onSuccess={fetchData} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsCancel = (id: number) => {
    modals.openConfirmModal({
      title: <Title order={5}>Hủy lịch cập nhật bảng giá</Title>,
      size: "auto",
      children: (
        <Box>
          <Text size="20px" fw={600} mt={10}>
            Bạn có chắc muốn hủy lịch cập nhật này ?
          </Text>
          <Flex justify={"end"} mt={10}>
            <Button
              leftSection={<IconCheck size={16} />}
              color="teal"
              onClick={() => handleCancelUpdate(id)}
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleDownload = async (filePath: string, fileName: string) => {
    try {
      const response = await fetch(String(filePath));
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = String(fileName) || "downloaded_file";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
      NotificationExtension.Success("Tải tệp thành công !");
    } catch (error) {
      console.error("Download failed:", error);
      NotificationExtension.Fails("Tải tệp thất bại !");
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblScheduleJob/get-list-price-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value) === "3" ? "-1" : String(value));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryDelivery.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      localStorage.setItem(
        keySearchSPLU,
        JSON.stringify({ ...search, keySearch: keySearch })
      );
    }
  };

  //   const exportDataExcel = async () => {
  //     open();
  //     try {
  //       let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //       const params = new URLSearchParams();
  //       Object.entries(search).forEach(([key, value]) => {
  //         if (
  //           value &&
  //           ((typeof value === "string" && value.length > 0) ||
  //             (Array.isArray(value) && value.length > 0))
  //         ) {
  //           params.append(key, String(value));
  //         }
  //       });

  //       if (keySearch.length > 0) {
  //         url += `&KeySearch=${keySearch?.trim()}`;
  //       }

  //       url += `&${params.toString()}`;

  //       const baseUrl = `/api/v1/ExportExcel/export-bao-cao-ton-kho-lap-may${url}`;

  //       const _url = BASE_API_MDM + baseUrl;
  //       const token = localStorage.getItem("token");

  //       const response = await fetch(_url, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/vnd.ms-excel",
  //           Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //         },
  //       });

  //       if (!response.ok) {
  //         NotificationExtension.Fails("Export Excel thất bại !");
  //       } else {
  //         const blob = await response.blob();
  //         const urlss = window.URL.createObjectURL(blob);
  //         const _name = new Date().toISOString().slice(0, 10);
  //         let filename = "bao_cao_ton_kho_lap_may.xlsx";
  //         const link = document.createElement("a");
  //         link.href = urlss;
  //         link.download = filename;
  //         document.body.appendChild(link);
  //         link.click();
  //         link.remove();
  //         window.URL.revokeObjectURL(url);
  //         NotificationExtension.Success("Export Excel thành công !");
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       close();
  //     }
  //   };

  const handleCancelUpdate = async (id: number) => {
    const _url = BASE_API_DELIVERY + `/api/v1/FileSchedule/cancel-job/${id}`;
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(_url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });

      if (response?.data?.success) {
        NotificationExtension.Success("Hủy lịch cập nhật thành công!");
        setTimeout(() => {
          modals.closeAll();
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails(response?.data?.message || "Hủy thất bại!");
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Có lỗi xảy ra khi hủy lịch cập nhật!";
      NotificationExtension.Fails(message);
    }
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    fetchDataEmp();
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem("columnPinningSPLU");
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["mrt-row-numbers"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem("columnPinningSPLU", JSON.stringify(columnPinning));
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (142.5 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconCalendar size={14} />}
            color="teal"
            onClick={() => modalsUpload("CREATE", null)}
          >
            Lập lịch
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái"
              leftSection={<IconStatusChange color="#15aabf" />}
              data={[
                { label: "Đã lên lịch", value: "0" },
                { label: "Cập nhật thành công", value: "1" },
                { label: "Cập nhật thất bại", value: "2" },
                { label: "Hủy cập nhật", value: "3" },
              ]}
              value={search?.Status}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "Status", setSearch)
              }
              clearable
              renderOption={renderSelectOptionStatus}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default SchedulePriceListUpload;
